import { client } from "../../../api/client";

export const fetchSalesforceCodes = async () => {
  try {
    const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "iquoteapi/salesforceCode");

    if (!response.ok) {
      console.error("Error fetching salesforceCodes:", response);
      return [];
    }

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("Error fetching salesforceCodes:", error);
    return [];
  }
};

export const updateSalesforceCode = async (salesforceCode) => {
    try {
      const response = await client.put(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/salesforceCode/" + salesforceCode.id, salesforceCode);
      const isSuccess = response.ok ?? (response.status >= 200 && response.status < 300);

      if (isSuccess) {
          return {
            success: true,
            message: "Salesforce Code updated successfully",
            salesforceCode: response.data?.salesforceCode ?? salesforceCode
          };
      }

      if (response.status === 403) {
          return {
            success: false,
            message: "You do not have permission to update Salesforce Codes",
            salesforceCode: null
          };
      }

      return {
        success: false,
        message: "Error updating Salesforce Code: " + (response.statusText || response.status),
        salesforceCode: null
      };
    } catch (error) {
        console.error("Error updating salesforceCode:", error);
        return { success: false, message: "error:" + error, salesforceCode: null }
    }
}

export const deleteSalesforceCode = async (salesforceCodeId) => {
  try {
    const response = await client.delete(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/salesforceCode/" + salesforceCodeId);
        if (response.status === 204) {
            return { success: true, message: "Salesforce Code deleted successfully" };
        } if (response.status === 403) {
          return { success: false, message: "You do not have permission to delete Salesforce Codes." };
        }  else {
          return { success: false, message: "Error deleting Salesforce Code. Code: " + response.status };
        }
      } catch (error) {
          console.error("Error deleting salesforceCode:", error);
          return { success: false, message: "Error deleting Salesforce Code: " + error, salesforceCode: null }
      }
}

export const createSalesforceCode = async (salesforceCode) => {
  try {
    const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/salesforceCode", salesforceCode);

    if (response.status === 201) {
        return { success: true, message: "Salesforce Code created successfully", salesforceCode: response.data?.salesforceCode };
    } else if (response.status === 403) {
        return { success: false, message: "You do not have permission to create Salesforce Codes.", salesforceCode: null };
    } else {
        return { success: false, message: "Error creating Salesforce Code: Status=" + response.status, salesforceCode: null };
    }
  } catch (error) {
      console.error("Error creating salesforceCode:", error);
      return { success: false, message: "error:" + error, salesforceCode: null }
  }
}